// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-error[data-v-1b9ca932]{height:100%;background:#f7f9fa;display:flex;align-items:center;flex-direction:column}.m-error .img-wrapper[data-v-1b9ca932]{margin-top:20vh;width:3.2rem;height:2.4rem}.m-error .img-wrapper img[data-v-1b9ca932]{width:100%;height:100%}.m-error .text[data-v-1b9ca932]{text-align:center;margin-top:.24rem;font-size:.28rem;color:#9da0a3}", ""]);
// Exports
module.exports = exports;
